import React, { memo } from 'react';
import Title from '@wconcept/wconcept-ui-renewal/components/atoms/Title';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import * as S from './style';

interface IProps {
  /** title */
  title?: string;
  /** className */
  className?: string;
  /** items */
  items?: React.ReactNode;
}

const FltBenefitBox = ({ title, className, items }: IProps) => (
  <S.FltBenefitBox className={className}>
    {title && <Title level={4}>{title}</Title>}
    <ul className="list">{items}</ul>
  </S.FltBenefitBox>
);

export default memo(FltBenefitBox);
